import {
  ButtonGroup,
  Container,
  TextField,
  Typography
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import $ from "jquery";
import React, { useEffect, useState } from "react";
import "../App.css";
import { getWordPHP, submitPHP, viewLocalStorage } from "../AppClass";
import { FetchData } from "../services/FetchData";

function TypingGame() {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [wordsArray, setwordsArray] = useState([]);
  const [results, setResults] = useState([]);
  useEffect(() => {
    console.log(results);
  }, [results]);

  const [userInput, setUserInput] = useState("");

  useEffect(() => {
    getWords();

    // $('#editableResult').change(function() {
    //    console.log('changed');
    // });
  }, []);

  const [open, setOpen] = React.useState(false);

  function getWords() {
    FetchData("/get_typing_words", {
      id: localStorage.getItem("auth_token")
    })
      .then(result => {
        //console.log(result);
        let resJson = JSON.parse(JSON.stringify(result));
        setwordsArray(resJson);
      })
      .catch(error => {});
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function submitWords() {
    //console.log("submitWords running", wordsArray, results);

    FetchData("/submit_typing_words", {
      id: localStorage.getItem("auth_token"),
      word: wordsArray,
      typed_words: results
    })
      .then(result => {
        //  *reset states
        setCurrentIndex(0);
        setOpen(false);
        setResults([]);
        setUserInput("");
        setwordsArray([]);
        // * get next 10 words
        getWords();
      })
      .catch(error => {});

    // $.ajax({
    //   url: submitPHP,
    //   method: "POST",
    //   data: {
    //     id: localStorage.getItem("auth_token"),
    //     word: wordsArray,
    //     typed_words: results
    //   },
    //   success: function(res) {
    //     //  *reset states
    //     setCurrentIndex(0);
    //     setOpen(false);
    //     setResults([]);
    //     setUserInput("");
    //     setwordsArray([]);
    //     // * get next 10 words
    //     getWords();
    //   },
    //   error: function(error) {
    //     console.log(error);
    //   }
    // });
  }

  function handleNext() {
    // * adding user input to results state

    if (results.length >= wordsArray.length) {
      setOpen(true);
    } else {
      setResults(oldArray => [...oldArray, userInput]);

      // * printing next word
      if (currentIndex >= wordsArray.length - 1) setOpen(true);
      else setCurrentIndex(previousIndex => previousIndex + 1);

      // * clear userInput state
      setUserInput("");
    }
  }

  // * handles enter press after typing each word
  function handleTextInputKeyDown(event) {
    if (event.key === "Enter") {
      if (userInput !== "") handleNext();
    }
  }

  function handleResultText(index, event) {
    // console.log(event.target.value);
    // console.log(results[index]);

    // 5. Set the state to our new copy
    let oldresults = results;
    let newvalue = event.target.value;
    oldresults[index] = newvalue;

    setResults([...oldresults]);
  }

  return (
    <Container maxWidth="md">
      <Card className={classes.card} elevation={1}>
        <Typography variant="subtitle1" gutterBottom color="primary">
          Type English equivalent of words
        </Typography>
        <Typography variant="h6" component="h2">
          {currentIndex + 1} out of {wordsArray.length} words
        </Typography>
        <CardContent>
          <Typography variant="h3" component="h2">
            {wordsArray.length > 0 && wordsArray[currentIndex]}
          </Typography>
          <TextField
            id="standard-name"
            label="Type english equivalent"
            fullWidth
            className={classes.textField}
            value={userInput}
            onChange={evt => setUserInput(evt.target.value)}
            margin="normal"
            autoComplete="off"
            onKeyDown={event => handleTextInputKeyDown(event)}
          />
          <ButtonGroup fullWidth aria-label="full width outlined button group">
            {/* <Button onClick={viewLocalStorage}>Console localStorage</Button> */}

            {/* <Button
                     disabled={currentIndex === 0}
                     onClick={() => {
                        setCurrentIndex(previousIndex => previousIndex - 1);
                     }}
                  >
                     Previous
                  </Button>
                  <Button
                     disabled={currentIndex === wordsArray.length - 1 || userInput === ''}
                     onClick={handleNext}
                  >
                     Next
                  </Button> */}
            <Button
              // onClick={submitWords}
              onClick={handleClickOpen}
              disabled={results.length <= wordsArray.length - 1}
            >
              Submit
            </Button>
          </ButtonGroup>
        </CardContent>
      </Card>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Review your submission"}
        </DialogTitle>
        <DialogContent>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Assamese word</TableCell>
                <TableCell align="right">English equivalent</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.map((row, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {wordsArray[index]}
                  </TableCell>
                  <TableCell align="right">
                    {/* <input defaultValue={results[index]}></input> */}
                    <TextField
                      id="editableResult"
                      // defaultValue={results[index]}
                      // onChange={(event, index) => handleResultText()}
                      onChange={event => handleResultText(index, event)}
                      value={results[index]}
                      margin="normal"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={submitWords} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

const useStyles = makeStyles(theme => {
  return {
    card: {
      textAlign: "center",
      minWidth: 275,
      margin: "100px",
      padding: 30,
      [theme.breakpoints.down("md")]: {
        margin: "30px 0",
        padding: 10
      }
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)"
    },
    title: {
      fontSize: 14
    },
    pos: {
      marginBottom: 12
    },
    textField: {
      margin: "50px 0"
    }
  };
});

export default TypingGame;
